@if (pageEnabled) {
  <div class="box flex">
    <h1>
      <span style="color: black;">On</span>
      <span style="color: #0093a1;">Call</span>
    </h1>
  </div>
}